import {
  Box,
  Typography,
  Button,
  DialogContent,
  CircularProgress,
} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { t } from 'i18next';
import { FinancialOptions } from '../useAddAccountNavigation';

export type ManualSaveStatus = 'idle' | 'saving' | 'success' | 'error';

interface ManualAccountBeingAddedProps {
  updateModalExperience: (experience: FinancialOptions) => void;
  onClose: () => void;
  saveStatus: ManualSaveStatus;
}

const ManualAccountBeingAdded = ({
  updateModalExperience,
  onClose,
  saveStatus,
}: ManualAccountBeingAddedProps) => {
  return (
    <>
      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2,
          }}
        >
          {saveStatus === 'saving' && <CircularProgress />}
          {saveStatus === 'success' && (
            <CheckCircleOutlineIcon
              color='success'
              sx={{ fontSize: 40 }}
            />
          )}
          {saveStatus === 'error' && (
            <ErrorOutlineIcon
              color='error'
              sx={{ fontSize: 40 }}
            />
          )}

          <Typography variant='h6'>
            {t('addAccountModal.accountBeingAdded')}
          </Typography>

          <Box textAlign='center'>
            <Typography variant='body2'>
              {t('addAccountModal.accountReadyNotification')}
            </Typography>
            <Typography variant='body2'>
              {t('addAccountModal.nextSteps')}
            </Typography>
          </Box>
        </Box>
      </DialogContent>

      {/* Footer */}
      <Box
        sx={{
          borderTop: '1px solid var(--divider, rgba(0, 0, 0, 0.12))',
          padding: 3,
        }}
      >
        <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
          <Button
            variant='outlined'
            type='button'
            onClick={() => {
              updateModalExperience(FinancialOptions.ADD_ACCOUNT);
            }}
          >
            {t('addAccountModal.footer.addAnother')}
          </Button>
          <Button
            variant='contained'
            type='button'
            onClick={onClose}
          >
            {t('addAccountModal.footer.done')}
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default ManualAccountBeingAdded;
